import { FormBoolean, ProjectModuleForm } from './form';

export class ProjectModuleFormOutput {
  // The schemaID is only needed when creating a new module
  schemaID?: string;
  status?: string;
  occupantRules?: string;
  teamMemberRules?: string;
  externalDeliveryContainerRules?: string;
  internalDeliveryContainerRules?: string;
  isQrDeliveryOnly?: FormBoolean;
  appName?: string;
  appInstallationUrl?: string;
  providerId?: string;
  carrierCode?: string;
  deactivateUsersAfterDays?: number | null;
  deliveredToRequirement?: string | null;

  constructor(form: ProjectModuleForm) {
    if (form.schemaID) this.schemaID = form.schemaID;
    if (form.status) this.status = form.status;
    if (form.occupantRules) this.occupantRules = form.occupantRules;
    if (form.teamMemberRules) this.teamMemberRules = form.teamMemberRules;
    if (form.externalDeliveryContainerRules) this.externalDeliveryContainerRules = form.externalDeliveryContainerRules;
    if (form.internalDeliveryContainerRules) this.internalDeliveryContainerRules = form.internalDeliveryContainerRules;
    if (form.providerId) this.providerId = form.providerId;
    if (form.carrierCode) this.carrierCode = form.carrierCode;
    // Not a truthiness check: 0 and null are both meaningful values for this field.
    if (form.deactivateUsersAfterDays !== undefined) this.deactivateUsersAfterDays = form.deactivateUsersAfterDays;
    if (form.deliveredToRequirement !== undefined) this.deliveredToRequirement = form.deliveredToRequirement;

    // Dry Cleaning specific fields
    if (form.isQrDeliveryOnly) this.isQrDeliveryOnly = form.isQrDeliveryOnly;
    if (form.appName) this.appName = form.appName;
    if (form.appInstallationUrl) this.appInstallationUrl = form.appInstallationUrl;
  }

  static ToSettingsData(output: ProjectModuleFormOutput): Record<string, any> {
    return {
      schemaID: output.schemaID,
      status: output.status,
      occupantRules: output.occupantRules,
      teamMemberRules: output.teamMemberRules,
      externalDeliveryContainerRules: output.externalDeliveryContainerRules,
      internalDeliveryContainerRules: output.internalDeliveryContainerRules,
      providerId: output.providerId,
      carrierCode: output.carrierCode,
      // This is a full-object PUT, so the current value must always be echoed back. Dropping it
      // reads as a change on the server and fails the settings:UpdateAdvanced check for callers
      // who only hold settings:UpdateBasic.
      deactivateUsersAfterDays: output.deactivateUsersAfterDays,
      // Also settings:UpdateAdvanced, so it is echoed back unchanged in the same way.
      deliveredToRequirement: output.deliveredToRequirement,

      // Dry Cleaning specific fields
      isQrDeliveryOnly: output.isQrDeliveryOnly === 'yes',
      appName: output.appName,
      appInstallationUrl: output.appInstallationUrl
    };
  }
}
